import React from "react";
import { JobsTableIframe } from "@rankmi/ats-app"

const JobsTable = ({ organizationSlug }) => {
  return (
    <div>
      <JobsTableIframe organizationSlug={organizationSlug} />
    </div>
  )
}

export default JobsTable